import CircleTickIcon from 'images/icons/CircleTick.svg';
import LocationIcon from 'images/icons/Location.svg';
import { ExtendedFullPageWidgetSettings } from 'types/settings';

import { Icon } from 'components/Icon';
import { useSettings } from 'components/SettingsProvider';
import { Stack } from 'components/Stack';
import { Stars } from 'components/Stars';
import { Text } from 'components/Text';

interface HeaderProps {
  author: string;
  title: string;
  rating: number;
  publishDate: string;
  location?: string;
  verified?: boolean;
}

export function Header({
  author,
  title,
  rating,
  publishDate,
  location,
  verified,
}: HeaderProps) {
  const { settings, show_date_creation } =
    useSettings<ExtendedFullPageWidgetSettings>();

  const locationMarkup = location ? (
    <div>
      <Stack spacing="extraTight" wrap={false} alignment="center">
        <Icon source={LocationIcon} />
        <Text size="small" as="span">
          {location}
        </Text>
      </Stack>
    </div>
  ) : null;

  const verifiedMarkup = verified ? <Icon source={CircleTickIcon} /> : null;

  const isShowDate =
    !settings.reviews?.tweaks.hide_date_creation && show_date_creation;

  const publishDateMarkup = isShowDate && (
    <Text variation="subdued" size="small">
      {publishDate}
    </Text>
  );

  return (
    <Stack vertical>
      <Stack.Item fill>
        <Stack alignment="center">
          <Stack.Item fill>
            <Stack alignment="center" spacing="extraTight">
              <Text size="small" variation="semiStrong">
                {author}
              </Text>
              {verifiedMarkup}
            </Stack>
          </Stack.Item>
          {publishDateMarkup}
        </Stack>
      </Stack.Item>
      <div>
        <Text size="large" variation="semiStrong" lineClamp={2}>
          {title}
        </Text>
      </div>
      <Stack>
        <Stack.Item fill>
          <div>
            <Stars value={rating} />
          </div>
        </Stack.Item>
        {locationMarkup}
      </Stack>
    </Stack>
  );
}
